import type { AssetsListResponse } from '@fleet-bffs/api-contract';
import { bffWebApi } from '~/api';
import type { InventoryV2PageArgs, InventoryV2PinArgs } from '../models/inventory-v2';
import { INVENTORY_V2_PAGE_SIZE } from '../models/inventory-v2';

const byIds = ({ filters, iprIds }: InventoryV2PinArgs) => ({
  url: `${process.env.ENDPOINT_BFF}/assets/list/partial`,
  method: 'POST',
  params: { take: iprIds.length, skip: 0, ...filters },
  body: { iprIds },
});

const inventoryV2ListApi = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    getInventoryV2Page: build.query<AssetsListResponse, InventoryV2PageArgs>({
      query: ({ filters, skip }) => ({
        url: `${process.env.ENDPOINT_BFF}/assets/list/partial`,
        params: { take: INVENTORY_V2_PAGE_SIZE, skip, ...filters },
      }),
    }),
    getInventoryV2Pins: build.query<AssetsListResponse, InventoryV2PinArgs>({
      query: byIds,
    }),
    getInventoryV2Matches: build.query<AssetsListResponse, InventoryV2PinArgs>({
      query: byIds,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetInventoryV2PageQuery, useGetInventoryV2PinsQuery } = inventoryV2ListApi;

export default inventoryV2ListApi;
